import { createContext, useContext } from 'react';

// The provider owns the authenticated, environment-specific release state.
export const OrbitAIAvailability = createContext(false);
export const useOrbitAIAvailable = () => useContext(OrbitAIAvailability);
